import styled from 'styled-components';

import { CardContainer } from './SelectTemplateBody';
import { Alert, Divider, Skeleton, Stack } from '@mui/material';
import { SpotlightCard, SpotlightPanel } from '@common/SpotlightPanels/SpotlightPanels';
import { TemplateType } from '@requests/templates';
import { SwitchAccountOutlined } from '@mui/icons-material';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

interface Props {
  isLoading: boolean;
  userCards: SpotlightCard[];
  telnyxCards: SpotlightCard[];
  category: TemplateType;
}

export const TemplateCards: React.FC<Props> = ({ isLoading, category, userCards, telnyxCards }) => {
  const isUserTemplateCategory = category === TemplateType.USER_DEFINED;
  const hasUserTemplates = userCards.length > 0;
  const showUserTemplates = !isUserTemplateCategory && hasUserTemplates;

  if (isLoading) {
    return (
      <CardContainer>
        {Array.from({ length: 8 }, (_, index) => index).map((index) => (
          <Skeleton
            key={index}
            variant='rectangular'
            animation='wave'
            height={'100%'}
            style={{ borderRadius: '0.5rem', minHeight: '14rem' }}
          />
        ))}
      </CardContainer>
    );
  }

  return (
    <Container>
      {!isUserTemplateCategory && (
        <CardContainer>
          {telnyxCards.map((card) => (
            <SpotlightPanel key={card.id} card={card} small intercomDataAttribute={card.intercomDataAttribute} />
          ))}
        </CardContainer>
      )}
      {showUserTemplates && <Divider sx={{ mb: 1 }} />}
      {showUserTemplates && (
        <Stack direction='row' spacing={1.5} alignItems={'center'}>
          <SwitchAccountOutlined fontSize={'small'} />
          <h3>User Templates</h3>
        </Stack>
      )}
      {hasUserTemplates && (
        <CardContainer>
          {userCards.map((card) => (
            <SpotlightPanel key={card.id} card={card} small intercomDataAttribute={card.intercomDataAttribute} />
          ))}
        </CardContainer>
      )}
      {!hasUserTemplates && isUserTemplateCategory && (
        <Alert severity='warning'>
          {`You have not created any user templates yet. While in a workflow, click "File" in the top left corner and then "Save as Template" to get started.`}
        </Alert>
      )}
    </Container>
  );
};
